import { RoleEnum } from './role.enum';

/**
 * Role set for the Breece admin panel (`/admin`). Centralised so the route guard and
 * the main-app entry link draw from one source of truth (mirrors `media-roles.ts`).
 *
 * `BreeceSupport` is a **system** role, so it is always checked at system level.
 *
 * BreeceSupport is the ONLY way in (spec, 2026-09-07 - it replaces the 2026-09-01 arrangement where
 * a system Admin was admitted implicitly). The guard checks the system permission list inline, and
 * the toolbar link uses `*showForPermissions` with `strict: true` - neither goes through
 * `selectCanAccessContent`'s blanket Admin grant: the API endpoints
 * behind the panel name `Role.BreeceSupport`, and `ValidateRole` rejects a system Admin outright on
 * such a gate, so an Admin admitted by the UI would find every request answering 403.
 *
 * Add further internal staff roles here (e.g. `UserAdmin`) if the panel's audience widens later.
 */
export const ADMIN_PANEL_ROLES: RoleEnum[] = [RoleEnum.BreeceSupport];
